import { api, handleApiError } from '@/lib/api';
import type {
  Offer,
  OfferListResponse,
  CreateOfferDTO,
  UpdateOfferDTO,
} from '../types';

export const offerApi = {
  list: async (): Promise<OfferListResponse> => {
    try {
      return await api.get<OfferListResponse>('/admin/offers');
    } catch (error) {
      handleApiError(error, { operation: 'list_offers' });
      throw error;
    }
  },

  create: async (data: CreateOfferDTO): Promise<Offer> => {
    try {
      // Convert Date to ISO string if needed
      const payload = {
        ...data,
        expires_at: data.expires_at instanceof Date 
          ? data.expires_at.toISOString() 
          : data.expires_at
      };
      return await api.post<Offer>('/admin/offers', payload);
    } catch (error) {
      handleApiError(error, { operation: 'create_offer', data });
      throw error;
    }
  },

  update: async (
    offerId: number,
    data: UpdateOfferDTO
  ): Promise<Offer> => {
    try {
      // Convert Date to ISO string if needed
      const payload = data.expires_at 
        ? {
            ...data,
            expires_at: data.expires_at instanceof Date 
              ? data.expires_at.toISOString() 
              : data.expires_at
          }
        : data;
      return await api.put<Offer>(`/admin/offers/${offerId}`, payload);
    } catch (error) {
      handleApiError(error, { operation: 'update_offer', offerId, data });
      throw error;
    }
  },

  delete: async (offerId: number): Promise<void> => {
    try {
      return await api.delete<void>(`/admin/offers/${offerId}`);
    } catch (error) {
      handleApiError(error, { operation: 'delete_offer', offerId });
      throw error;
    }
  },
};